module.exports = "./assets/assets/相关政策依据.f265ba4e.docx";